"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultRetentionFieldsSettings = void 0;
const core_1 = require("../../../core");
const constants_1 = require("../constants");
require("../types");
const getDefaultRetentionFieldsSettings = (value) => {
    return {
        rowFirstFieldCountMin: value.rowFirstFieldCountMin || constants_1.RETENTION_COUNT_MIN,
        rowFirstFieldCountMax: value.rowFirstFieldCountMax || constants_1.RETENTION_COUNT_MAX,
        rowFirstFieldCountInitialValue: value.rowFirstFieldCountInitialValue || constants_1.RETENTION_COUNT_MIN,
        rowFirstFieldTypeInitialValue: value.rowFirstFieldTypeInitialValue || core_1.RETENTION_TYPE.days,
        rowSecondFieldCountMin: value.rowSecondFieldCountMin || constants_1.RETENTION_COUNT_MIN,
        rowSecondFieldCountMax: value.rowSecondFieldCountMax || constants_1.RETENTION_COUNT_MAX,
        rowSecondFieldCountInitialValue: value.rowSecondFieldCountInitialValue || constants_1.RETENTION_COUNT_MIN,
        rowSecondFieldTypeInitialValue: value.rowSecondFieldTypeInitialValue || core_1.RETENTION_TYPE.days,
        rowThirdFieldCountMin: value.rowThirdFieldCountMin || constants_1.RETENTION_COUNT_MIN,
        rowThirdFieldCountMax: value.rowThirdFieldCountMax || constants_1.RETENTION_COUNT_MAX,
        rowThirdFieldCountInitialValue: value.rowThirdFieldCountInitialValue || constants_1.RETENTION_COUNT_MIN,
        rowThirdFieldTypeInitialValue: value.rowThirdFieldTypeInitialValue || core_1.RETENTION_TYPE.days,
    };
};
exports.getDefaultRetentionFieldsSettings = getDefaultRetentionFieldsSettings;
//# sourceMappingURL=getDefaultRetentionFieldsSettings.js.map